<template>
	<div class="template contact">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Title}}<span v-show="dataVal.Require" class="require">*</span> </label>
			<div class="input_value">{{dataVal.Placeholder}}<span class="icon-right"></span> </div>
		</div>
	</div>
</template>

<script>
	export default{
		props: ['dataVal'],
		data(){
			return{
				
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';
</style>
